import { useId } from 'react';
import PopupState, { bindToggle, bindPopper } from 'material-ui-popup-state';
import Popper from '@mui/material/Popper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import * as Table from '../Table';
import styles from './styles/Draggable.module.css';
import { MoreHorizontalAnchor } from '../presentation/Anchor';

type Props = {
  popupId?: string;
  renderContent: (close: () => void) => React.ReactNode;
};

export const Cell = (props: Props) => {
  const fallbackPopupId = useId();
  return (
    <Table.Body.TD className={styles.actions}>
      <PopupState popupId={props.popupId ?? fallbackPopupId} variant="popper">
        {(popup) => (
          <div>
            <div {...bindToggle(popup)}>
              <MoreHorizontalAnchor className={styles.more} open={popup.isOpen} />
            </div>
            <Popper {...bindPopper(popup)} placement="bottom">
              <ClickAwayListener onClickAway={() => popup.close()}>
                {<div>{props.renderContent(popup.close)}</div>}
              </ClickAwayListener>
            </Popper>
          </div>
        )}
      </PopupState>
    </Table.Body.TD>
  );
};

Cell.displayName = 'Column.Actions.Cell';

export const Header = (props: unknown) => {
  return <Table.Header.TH className={styles.actions} />;
};

Header.displayName = 'Column.Actions.Header';
